/**
 * Route for `event-match-quality-emq-improvement-via-server-sid`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { EventMatchQualityEmqImprovementViaServerSidPage } from "../features/event-match-quality-emq-improvement-via-server-sid/EventMatchQualityEmqImprovementViaServerSidPage";

export const eventMatchQualityEmqImprovementViaServerSidRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/event-match-quality-emq-improvement-via-server-sid",
	component: EventMatchQualityEmqImprovementViaServerSidPage,
});

export default eventMatchQualityEmqImprovementViaServerSidRoute;
